enum nodesTypes {
    site = 'site',
    container = 'container',
    network = 'network',
    component = 'component',
}

export default nodesTypes;
